<template>
  <div class="student-record-detail">
    <div class="tabs-list">
      <el-tabs v-model="tabSelectName" @tab-click="handleClick">
        <el-tab-pane v-for="(item, index) in tabItems" :key="index" :name="item.name">
          <span slot="label">
            <span>{{ item.label }}</span>
          </span>
        </el-tab-pane>
      </el-tabs>
    </div>
    <studentRecordDetailTopBar ref="topBar" @addRecord="addRecord" :searchData="searchData"
      :semesterOptions="semesterOptions" :tabSelectName="tabSelectName" @search="search" />
    <div class="table">
      <!-- 家庭沟通-师生互动-学生行为表格 -->
      <el-table v-show="tabSelectName !== 'fourth' && tabSelectName !== 'fifth' && tabSelectName !== 'sixth'"
        :data="tableData" border style="width: 100%">
        <el-table-column v-for="col in tableColumns" :key="col.prop" :prop="col.prop" :label="col.label" />
        <el-table-column label="操作" width="220px">
          <template slot-scope="scope">
            <div class="handle-container">
              <el-button v-if="tabSelectName != 'third'" type="success" size="small"
                @click="detailClick(scope.row, '详情')">详情
              </el-button>
              <el-button v-if="tabSelectName != 'third'" type="warning" size="small"
                @click="detailClick(scope.row, '修改')" v-hasPermi="'sc:studentrecord:edit'">修改
              </el-button>
              <el-button v-if="tabSelectName != 'third'" type="danger" size="small" @click="delClick(scope.row)"
                v-hasPermi="'sc:studentrecord:delete'">删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 成绩追踪表格 -->
      <el-table v-show="tabSelectName === 'fourth'" :data="examDetails" style="width: 100%">
        <el-table-column label="考试名称" width="140px">
          <template slot-scope="{ row }">
            {{ row.title }} <br /> {{ row.subTitle }}
          </template>
        </el-table-column>
        <el-table-column prop="gradeName" label="年级" width="65px">
        </el-table-column>
        <el-table-column prop="studentName" label="姓名" width="85px">
        </el-table-column>
        <el-table-column prop="studentNumber" label="学号" width="75px">
        </el-table-column>
        <el-table-column prop="date" label="学年学期" width="120px">
          <template slot-scope="{ row }">
            {{ row.schoolYear }} <br /> {{ row.semester == "1" ? "第一学期" : "第二学期" }}
          </template>
        </el-table-column>
        <el-table-column prop="totalScore" label="总分" width="70px">
        </el-table-column>
        <el-table-column prop="avgScore" label="平均分" width="70px">
        </el-table-column>
        <el-table-column prop="overallPassRate" label="全科及格率" width="70px">
        </el-table-column>
        <el-table-column prop="gradeMaxScore" label="年级最高分" width="70px">
        </el-table-column>
        <el-table-column prop="gradeMaxGap" label="最高分差距(年级)">
        </el-table-column>
        <el-table-column prop="gradeAvgScore" label="年级平均分" width="70px">
        </el-table-column>
        <el-table-column prop="gradeAvgGap" label="平均分差距(年级)">
        </el-table-column>
        <el-table-column prop="gradeRank" label="年级排名" width="60px">
        </el-table-column>
        <el-table-column prop="gradeAdvanceRank" label="年级进步名次" width="70px">
        </el-table-column>
        <el-table-column prop="classMaxScore" label="班级最高分" width="70px">
        </el-table-column>
        <el-table-column prop="classMaxGap" label="最高分差距(班级)">
        </el-table-column>
        <el-table-column prop="classAvgScore" label="班级平均分" width="70px">
        </el-table-column>
        <el-table-column prop="classAvgGap" label="平均分差距(班级)">
        </el-table-column>
        <el-table-column prop="classRank" label="班级排名" width="60px">
        </el-table-column>
        <el-table-column prop="classAdvanceRank" label="班级进步名次" width="70px">
        </el-table-column>
        <el-table-column label="操作" width="120px">
          <template slot-scope="{ row }">
            <div>
              <el-button type="success" @click="barChartDialogShow(row)"> 统计图
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 基本信息表格 -->
      <div class="form-container" v-if="tabSelectName === 'fifth' && studentDetailInfo">
        <!-- 学生基本情况 -->
        <table class="form-table">
          <tr>
            <td colspan="6" class="section-header">一、学生基本情况</td>
          </tr>
          <tr>
            <td class="label">学生姓名</td>
            <td class="input-cell"> {{ studentDetailInfo.studentName }} </td>
            <td class="label">班级</td>
            <td class="input-cell"> {{ studentDetailInfo.gradeName + studentDetailInfo.className }} </td>
            <td class="label">性别</td>
            <td class="input-cell"> {{ studentDetailInfo.sex == 1 ? '男' : '女' }} </td>
          </tr>
          <tr>
            <td class="label">学生联系电话</td>
            <td class="input-cell"> {{ studentDetailInfo.studentPhone }} </td>
            <td class="label">家长联系电话</td>
            <td class="input-cell"> {{ studentDetailInfo.patriarchPhone }} </td>
            <td class="label">民族</td>
            <td class="input-cell"> {{ studentDetailInfo.nation }} </td>
          </tr>
          <tr>
            <td class="label">籍贯</td>
            <td class="input-cell"> {{ studentDetailInfo.nativePlace }} </td>
            <td class="label">现家庭住址</td>
            <td class="input-cell" colspan="3"> {{ studentDetailInfo.address }} </td>
          </tr>
        </table>

        <!-- 家庭相关情况 -->
        <table class="form-table">
          <tr>
            <td colspan="8" class="section-header">二、家庭相关情况</td>
          </tr>
          <tr v-for="(item, index) in familyData" :key="index">
            <td class="label">姓名</td>
            <td class="input-cell">{{ item.familyMember }} </td>
            <td class="label">关系</td>
            <td class="input-cell">{{ item.relationship }}</td>
            <td class="label">工作单位</td>
            <td class="input-cell">{{ item.workplace }}</td>
            <td class="label">联系电话</td>
            <td class="input-cell">{{ item.phone }}</td>
          </tr>
        </table>

        <!-- 学生学习活动情况 -->
        <table class="form-table">
          <tr>
            <td colspan="6" class="section-header">三、学生学习活动情况</td>
          </tr>
          <tr>
            <td class="checkbox-row" colspan="6">
              <div class="checkbox-container">
                <el-checkbox-group v-model="checkExperienceList" @change="handleExperienceChange">
                  <el-checkbox v-for="(item, index) in importantEventOptions" :key="index"
                    :label="item.dictLabel"></el-checkbox>
                </el-checkbox-group>

                <!-- 其它重大事件备注输入框 -->
                <el-input v-if="showOtherRemarkInput" v-model="otherRemark" placeholder="请输入其它重大事件的备注"
                  style="margin-let: 10px" />
              </div>
            </td>
          </tr>
        </table>

        <!-- 评价表格 -->
        <table class="evaluation-table">
          <tr>
            <td class="eval-label">学生是否适应</td>
            <td v-for="(item, index) in evaluateBodyOptions" :key="index" class="eval-header">{{ item.dictLabel }}</td>
          </tr>
          <tr v-for="item in studentLifeList" :key="item.id">
            <td class="eval-item">{{ item.evaluateItem }}</td>
            <!-- 每一列 -->
            <td v-for="(col, index) in evaluateBodyOptions" :key="col.dictValue"
              @click="toggleSelection(item.id, col.dictValue)" class="eval-cell"
              :class="{ active: getSelectionStatus(item.id, col.dictValue) }">
              <span v-if="getSelectionStatus(item.id, col.dictValue)">✔</span>
            </td>
          </tr>
        </table>

        <!-- 底部说明 -->
        <!-- <div class="footer-note">
          注：为了更好地了解每一位学生学生的健康成长状况，请各位同学认真填写本表，如实填写，以上信息我们将会妥善保管，不得泄露。
        </div> -->
        <div class="footer-btn">
          <el-button type="primary" @click="studentDetailInfoSubmit" v-hasPermi="'sc:studentrecord:edit'">确认</el-button>
        </div>
      </div>
      <!-- 综合素质评定表格 -->
      <div class="evaluation-container" v-if="tabSelectName === 'sixth' && comprehensiveDetailsByParam">
        <table class="evaluation-table">
          <!-- 第一行：学生基本信息 -->
          <tr>
            <td :colspan="2" class="info-label" style="width: 200px;">学生姓名</td>
            <!-- <td :colspan="2" class="editable-cell" @click="handleEdit('studentName')">
              {{ comprehensiveDetailsByParam.studentName }}
            </td> -->
            <td :colspan="2">
              {{ studentInfo.studentName }}
            </td>
            <td :colspan="2" class="info-label">职务</td>
            <td :colspan="2" class="editable-cell" @click="handleEdit('classPosition', '职务')">
              {{ comprehensiveDetailsByParam.classPosition }}
            </td>
            <td :colspan="2" class="info-label">所在班级</td>
            <!-- <td :colspan="3" class="editable-cell" @click="handleEdit('gradeName.className')">
              {{ comprehensiveDetailsByParam.gradeName + comprehensiveDetailsByParam.className }}
            </td> -->
            <td :colspan="3">
              {{ studentInfo.gradeName + studentInfo.className }}
            </td>
          </tr>

          <!-- 第二行：学科标题 -->
          <!-- <tr>
            <td></td>
            <td></td>
            <td class="subject-header">语文</td>
            <td class="subject-header">数学</td>
            <td class="subject-header">英语</td>
            <td class="subject-header">体育</td>
            <td class="subject-header">生物</td>
            <td class="subject-header">物理</td>
            <td class="subject-header">地理</td>
          </tr>

          <tr>
            <td class="item-title" :rowspan="2">学业表现</td>
            <td class="item-title">期中</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td class="item-title">期末</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr> -->

          <tr>
            <td class="item-title" :rowspan="2" :colspan="2">项目</td>
            <td class="requirement-title" :rowspan="2">要求</td>
            <td class="item-title" :colspan="evaluateBodyOptions.length">自评</td>
            <td class="item-title" :colspan="evaluateBodyOptions.length">教师评</td>
          </tr>

          <tr>
            <!-- 自评标题 -->
            <td v-for="(item, index) in evaluateBodyOptions" :key="'self-' + index" class="rating-example">
              {{ item.dictLabel }}
            </td>

            <!-- 教师评标题 -->
            <td v-for="(item, index) in evaluateBodyOptions" :key="'teacher-' + index" class="rating-example">
              {{ item.dictLabel }}
            </td>
          </tr>

          <!-- 评价标准示例行 -->
          <template v-for="(item, index) in comprehensiveQualityItem">
            <tr>
              <td class="item-title" :rowspan="item.childQualityItem.length + 1">{{ item.qualityItem }}</td>
            </tr>
            <tr v-for="(cItem, i) in item.childQualityItem" :key="'quality' + index + i">
              <td class="item-name">{{ i + 1 }}.{{ cItem.qualityItem }}</td>
              <td class="criteria-text">
                <span v-for="(dItem, dIndex) in cItem.childQualityItem" :key="'detail' + index + i + dIndex">({{ dIndex
                  + 1 }}) {{ dItem.qualityItem }}<br></span>
              </td>
              <!-- 自评列 -->
              <td class="editable-cell" v-for="(option, oIndex) in evaluateBodyOptions" :key="'self-' + oIndex"
                @click="selectScore(cItem, 'self', option)" :class="{ active: isSelected(cItem, 'self', option) }">
                <span v-if="isSelected(cItem, 'self', option)">✔</span>
              </td>

              <!-- 教师评列 -->
              <td class="editable-cell" v-for="(option, oIndex) in evaluateBodyOptions" :key="'teacher-' + oIndex"
                @click="selectScore(cItem, 'teacher', option)"
                :class="{ active: isSelected(cItem, 'teacher', option) }">
                <span v-if="isSelected(cItem, 'teacher', option)">✔</span>
              </td>
            </tr>
          </template>

          <tr>
            <td class="item-title">学生总结</td>
            <td :colspan="evaluateBodyOptions.length + 7" class="summary-content"
              @click="handleEdit('studentSummary', '学生总结')">
              {{ comprehensiveDetailsByParam.studentSummary || '点击编辑' }}
            </td>
          </tr>

          <tr>
            <td class="item-title">老师意见</td>
            <td :colspan="evaluateBodyOptions.length + 7" class="summary-content"
              @click="handleEdit('teacherMessage', '老师意见')">
              {{ comprehensiveDetailsByParam.teacherMessage || '点击编辑' }}
            </td>
          </tr>

          <tr>
            <td class="item-title">家长意见</td>
            <td :colspan="evaluateBodyOptions.length + 7" class="summary-content"
              @click="handleEdit('patriarchMessage', '家长意见')">
              {{ comprehensiveDetailsByParam.patriarchMessage || '点击编辑' }}
            </td>
          </tr>
        </table>
        <div class="footer-btn">
          <el-button type="primary" @click="submitEvaluateBody" v-hasPermi="'sc:studentrecord:edit'">确认</el-button>
        </div>
      </div>
    </div>
    <!-- 学生排行-分页容器 -->
    <div class="pagination-catainer">
      <pagination :total="parseInt(total)" :pageSize="parseInt(pageInfo.pageSize)"
        @currentPageNumChange="currentPageNumChange" @handleSizeChange="handleSizeChange" />
    </div>
    <!-- 家校沟通新增 -->
    <communicationAddDialog v-show="communicationAddDialogShow" @refresh="refresh"
      :communicationAddDialogShow.sync="communicationAddDialogShow" :semesterOptions="semesterOptions"
      :studentId="studentId" :studentName="studentName" :communicationMethodOptions="communicationMethodOptions" />
    <!-- 家校沟通详情 -->
    <communicationDetailDialog v-if="communicationDetailDialogShow" @refresh="refresh"
      :communicationDetailDialogShow.sync="communicationDetailDialogShow" :semesterOptions="semesterOptions"
      :studentId="studentId" :studentName="studentName" :detailData="detailData" :detailType="detailType"
      :communicationMethodOptions="communicationMethodOptions" />
    <!-- 师生互动新增 -->
    <interactionAddDialog v-show="interactionAddDialogShow" @refresh="refresh" :semesterOptions="semesterOptions"
      :interactionAddDialogShow.sync="interactionAddDialogShow" :studentInfo="studentInfo" :studentId="studentId"
      :studentName="studentName" :teacherId="teacherId" :teacherName="teacherName"
      :studentDetailInfo="studentDetailInfo" :talkStudentInfo="talkStudentInfo" />
    <!-- 师生互动详情 -->
    <interactionDetailDialog v-if="interactionDetailDialogShow" @refresh="refresh"
      :interactionDetailDialogShow.sync="interactionDetailDialogShow" :studentInfo="studentInfo"
      :detailData="detailData" :detailType="detailType" :semesterOptions="semesterOptions"
      :talkStudentInfo="talkStudentInfo" :teacherId="teacherId" :teacherName="teacherName"
      :talkRecordDetailsList="talkRecordDetailsList" @selectTalkRecordDetailsList="selectTalkRecordDetailsList" />
    <!-- 学生行为新增 -->
    <behaviorAddDialog v-show="behaviorAddDialogShow" @refresh="refresh" :semesterOptions="semesterOptions"
      :studentId="studentId" :studentName="studentName" :behaviorAddDialogShow.sync="behaviorAddDialogShow" />
    <!-- 学生行为详情 -->
    <behaviorDetailDialog v-if="behaviorDetailDialogShow" :semesterOptions="semesterOptions"
      :behaviorDetailDialogShow.sync="behaviorDetailDialogShow" :detailData="detailData" />
    <barChartDialog v-show="chartDialogShow" :chartDialogShow.sync="chartDialogShow"
      :courseScoreList="courseScoreList" />
  </div>
</template>

<script>
import studentRecordDetailTopBar from "./components/student-record-detail-topBar/studentRecordDetailTopBar.vue";
import communicationAddDialog from "./components/communication-add-dialog/communicationAddDialog.vue";
import communicationDetailDialog from "./components/communication-detail-dialog/communicationDetailDialog.vue";
import interactionAddDialog from "./components/interaction-add-dialog/interactionAddDialog.vue";
import interactionDetailDialog from "./components/interaction-detail-dialog/interactionDetailDialog.vue";
import behaviorAddDialog from "./components/behavior-add-dialog/behaviorAddDialog.vue";
import behaviorDetailDialog from "./components/behavior-detail-dialog/behaviorDetailDialog.vue";
import barChartDialog from "./components/bar-chart-dialog/barChartDialog.vue";
import pagination from "@/components/pagination/pagination";
export default {
  components: {
    studentRecordDetailTopBar,
    communicationAddDialog,
    communicationDetailDialog,
    interactionAddDialog,
    interactionDetailDialog,
    behaviorAddDialog,
    behaviorDetailDialog,
    barChartDialog,
    pagination
  },
  data() {
    return {
      activities: {
        lawEducation: false,
        familyVirtue: false,
        violentBehavior: false,
        otherEvents: false,
        otherEventsDetail: ''
      },
      // evaluationItems: [
      //   '学习成绩',
      //   '学习态度',
      //   '考试心理',
      //   '自控能力',
      //   '睡眠状况',
      //   '精神状态',
      //   '业余活动',
      //   '与同学关系',
      //   '与老师关系'
      // ],
      studentId: "",
      studentName: "",
      interviewTime: "", // 记录时间
      tabSelectName: "first",
      tabItems: [
        { label: '家校沟通', name: 'first', permissionField: "", },
        { label: '师生互动', name: 'second', permissionField: "", },
        { label: '学生行为', name: 'third', permissionField: "", },
        { label: '成绩追踪', name: 'fourth', permissionField: "", },
        { label: '基本信息', name: 'fifth', permissionField: "", },
        { label: '综合素质评定', name: 'sixth', permissionField: "", },
      ],
      total: 0,
      pageInfo: {
        pageSize: 10,
        pageNum: 1,
      },
      tableData: [],
      detailData: null, // 通用详情数据
      communicationAddDialogShow: false, // 家校沟通新增
      communicationDetailDialogShow: false, // 家校沟通详情
      interactionAddDialogShow: false, // 师生互动新增
      interactionDetailDialogShow: false, // 师生互动详情
      behaviorAddDialogShow: false, // 学生行为新增
      behaviorDetailDialogShow: false, // 学生行为详情
      examDetails: [], // 成绩追踪数据
      chartDialogShow: false, // 成绩追踪统计图弹窗
      courseScoreList: [], // 统计图数据
      semesterOptions: [], // 学期选择列表
      searchData: {
        semester: "",
        schoolYear: "",
        interviewTime: ""
      },
      examDetails: null,
      teacherId: "",
      teacherName: "",
      communicationMethodOptions: [], // 家校沟通方式
      studentInfo: null, // 学生详情的基本信息
      talkStudentInfo: {
        studentName: '',
        sex: '',
        age: null,
        className: '',
        patriarchName: '',
        relationship: '',
        patriarchPhone: '',
        overview: '',
        schoolYear: "",
        semester: "",
      }, // 师生互动学生基本信息
      importantEventOptions: [], // 重大事件字典
      // experienceList: [], // 学生绑定的重大事件列表
      checkExperienceList: [], // 选中的重大事件列表
      showOtherRemarkInput: false, // 其它重大事件备注
      otherRemark: '', // 其它重大事件备注
      studentDetailInfo: null, // 学生基本信息的详情
      studentLifeList: [], // 学生生活评定项目
      familyData: [], // 家庭成员
      evaluateBodyOptions: [], // 评定主体字典
      // 用于存储学生评定项表格选中值的对象
      evaluationResults: {},
      hasExperience: false, // 是否有重大事件
      experienceId: null, // 重大事件ID-修改时用
      comprehensiveDetailsByParam: {
        classPosition: "",
        patriarchMessage: "",
        studentSummary: "",
        teacherMessage: "",
      }, // 综合素质评定-基础信息
      comprehensiveAssessmentList: [], // 综合素质评定-评定项记录
      comprehensiveQualityItem: [], // 综合素质评定-评定项目列表
      isHasComprehensiveQualityDetails: false, // 综合素质评定-是否已有基础信息
      talkRecordDetailsList: [], // 师生互动详情记录列表
      detailType: '修改', // 家校，师生，学生行为三个点击详情时类型，主要是师生互动弹窗的显示
      // talkStudentInfo: {}, // 师生互动学生基本信息
    };
  },
  created() {
    this.teacherId = this.$route.query.teacherId;
    this.teacherName = this.$route.query.teacherName;
    this.studentInfo = JSON.parse(this.$route.query.studentInfo);
    this.studentId = this.studentInfo.id;
    this.studentName = this.studentInfo.studentName;
    // console.log(this.studentInfo);

    this.getSchoolDetails();
    this.getSemesterType();
    this.getCommunicationMethod();
    this.getImportantEvent();
    this.getEvaluateBody();
  },
  // 在 data 或 computed 中定义列配置
  computed: {
    tableColumns() {
      const columns = {
        first: [
          { prop: 'teacherName', label: '教师名称' },
          { prop: 'interviewTime', label: '沟通日期' },
          { prop: 'interviewee', label: '被访家长' },
          { prop: 'talkTopic', label: '谈话主题' }
        ],
        second: [
          { prop: 'interactLocation', label: '地点' },
          // { prop: 'patriarchName', label: '家长名称' },
          // { prop: 'gradeName', label: '年级' },
          // { prop: 'className', label: '班级' },
          { prop: 'interactTime', label: '日期' }
        ],
        third: [
          { prop: 'recordTime', label: '日期' },
          { prop: 'tutorName', label: '导师名称' },
          { prop: 'teacherChargeName', label: '班主任名称' }
        ]
      };
      return columns[this.tabSelectName] || [];
    }
  },
  methods: {
    search(data) {
      this.searchData = data;
      this.refresh();
    },
    // 查询学校信息
    getSchoolDetails() {
      this.get(this.$url.getSchoolDetails).then((res) => {
        let schoolInfo = res.data;
        this.searchData.semester = schoolInfo.semester;
        this.searchData.schoolYear = schoolInfo.schoolYear;
        this.$refs.topBar.schoolYearVal = schoolInfo.schoolYear;
        this.$refs.topBar.semesterVal = schoolInfo.semester;
        // 先获取学年学期，再获取记录列表
        this.refresh();
      });
    },
    delClick(row) {
      this.$confirm("是否删除该记录?", "删除", {
        confirmButtonText: "确定",
        cancelButtomText: "取消",
        type: "warning",
        confirmButtonClass: "confirm",
      })
        .then(() => {
          let action = "";
          if (this.tabSelectName == 'first') {
            // 家校沟通
            action = this.$url.deleteSchoolHomeInterview;
          };
          if (this.tabSelectName == 'second') {
            // 师生互动
            action = this.$url.deleteTeacherStudentInteract;
          };
          if (this.tabSelectName == 'third') {
            // 学生行为
            action = this.$url.deleteStudentBehavior;
          }
          this.delete(action + '?id=' + row.id).then((res) => {
            if (res.code !== 200) return this.$message.error(res.msg);
            this.$message.success(res.msg);
            this.refresh();
          });
        })
        .catch(() => { });
    },
    // 获取学期类型选择列表数据
    getSemesterType() {
      this.get(`${this.$url.getDictType}/semester_type`).then((res) => {
        // console.log("学期类型==>", res);
        this.semesterOptions = res.data;
      });
    },
    // 获取家校沟通方式数据
    getCommunicationMethod() {
      this.get(`${this.$url.getDictType}/sc_communication_method`).then((res) => {
        this.communicationMethodOptions = res.data;
      });
    },
    // interviewTimeSearch(e) {
    //   this.interviewTime = e;
    //   this.refresh();
    // },
    // 家校沟通列表
    selectSchoolHomeInterviewList() {
      let data = {
        studentId: this.studentId,
        schoolYear: this.searchData.schoolYear,
        semester: this.searchData.semester,
        interviewTime: this.searchData.interviewTime,
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize,
        teacherId: this.teacherId
      };
      this.get(this.$url.selectSchoolHomeInterviewList, data).then(res => {
        if (res.code !== 200) return this.$message.error(res.msg);
        // console.log("家校沟通：", res);
        this.tableData = res.rows ? res.rows : [];
        this.total = res.total;
      })
    },
    // 师生互动列表
    selectTeacherStudentInteractList() {
      let data = {
        // talkrecordMainId: this.studentId,
        schoolYear: this.searchData.schoolYear,
        semester: this.searchData.semester,
        // interactTime: this.searchData.interviewTime,
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize,
        studentId: this.studentId,
        // teacherId: this.teacherId
      };
      this.get(this.$url.selectTalkStudentInfoList, data).then(res => {
        if (res.code !== 200) return this.$message.error(res.msg);
        // console.log("师生互动：", res);
        this.tableData = res.rows ? res.rows : [];
        this.total = res.total;
      })
    },
    selectTalkRecordDetailsList() {
      let data = {
        // talkrecordMainId: id,
        schoolYear: this.searchData.schoolYear,
        semester: this.searchData.semester,
        // interactTime: this.searchData.interviewTime,
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize,
        studentId: this.studentId,
        // teacherId: this.teacherId
      };
      this.get(this.$url.selectTeacherStudentInteractList, data).then(res => {
        if (res.code !== 200) return this.$message.error(res.msg);
        // console.log("师生互动：", res);
        // if (res.rows) {
        //   this.talkRecordDetailsList = res.rows.map(item => {
        //     return {
        //       ...item,
        //       interactTime: this.formatDate(item.interactTime)
        //     };
        //   });
        // } else {
        //   this.talkRecordDetailsList = [];
        // };
        this.tableData = res.rows ? res.rows.map(item => {
          item.studentName = this.studentName;
          return item; // ✅ 必须返回 item
        }) : [];
        this.total = res.total;
        // // 师生互动
        // this.interactionDetailDialogShow = true;
      })
    },
    formatDate(str) {
      const match = str.match(/(\d{4})年(\d{2})月(\d{2})日/);
      if (match) {
        const year = match[1];
        const month = match[2];
        const day = match[3];
        return `${year}-${month}-${day}`; // 输出：2025-08-20
      }
      return null; // 或抛出错误
    },
    // 学生行为记录列表
    selectStudentBehaviorList() {
      let data = {
        studentId: this.studentId,
        schoolYear: this.searchData.schoolYear,
        semester: this.searchData.semester,
        recordTime: this.searchData.interviewTime,
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize,
        teacherId: this.teacherId
      };
      this.get(this.$url.selectStudentBehaviorList, data).then(res => {
        if (res.code !== 200) return this.$message.error(res.msg);
        // console.log("学生行为记录：", res);
        this.tableData = res.rows ? res.rows : [];
        this.total = res.total;
      })
    },
    selectAllExamInfoByStudentId() {
      this.get(
        this.$url.selectAllExamInfoByStudentId +
        "?studentId=" +
        this.studentId
      )
        .then((res) => {
          // console.log("查询学生成绩详情=>", res);
          if (!res.data) {
            // this.$message.warning("学生成绩详情为空");
            return;
          }

          // 考试信息
          this.examDetails = res.data;
        })
        .catch((err) => {
          console.log("学生考试详情报错==>", err);
          this.$message.error("获取考试信息失败，请稍后再试");
        });
    },
    // 成绩追踪查看统计图点击
    barChartDialogShow(row) {
      this.chartDialogShow = true;
      this.courseScoreList = row.examCourseList;
    },
    // 修改点击
    detailClick(row, type) {
      // console.log(row);

      this.detailData = row;
      this.detailType = type;
      if (this.tabSelectName == 'first') {
        // 家校沟通
        this.communicationDetailDialogShow = true;
      };
      if (this.tabSelectName == 'second') {
        // 查询学生基本信息
        // this.selectTalkStudentInfoById(row.talkrecordMainId);
        // this.selectTalkRecordDetailsList(row.id);
        this.interactionDetailDialogShow = true;
      };
      if (this.tabSelectName == 'third') {
        // 学生行为
        this.behaviorDetailDialogShow = true;
      }
    },
    // 查询学生基本信息
    selectTalkStudentInfoById(id) {
      this.get(this.$url.selectTalkStudentInfoById + "?id=" + id).then(res => {
        if (res.code == 200) {
          // console.log(res);
          this.talkStudentInfo = res.data;
          // 师生互动
          this.interactionDetailDialogShow = true;
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    // 师生互动-查询学生信息
    getTalkStudentInfo() {
      let data = {
        studentId: this.studentId,
        schoolYear: this.searchData.schoolYear,
      };
      this.get(this.$url.selectTalkStudentInfoList, data).then(res => {
        if (res.code !== 200 && !res.rows.length || !res.rows || res.total == 0) return this.interactionAddDialogShow = true;;
        this.talkStudentInfo = res.rows[0];
        // 师生互动
        this.interactionAddDialogShow = true;
      })
    },
    // 新增点击
    addRecord() {
      if (this.tabSelectName == 'first') {
        // 家校沟通
        this.communicationAddDialogShow = true;
      };
      if (this.tabSelectName == 'second') {
        this.getTalkStudentInfo();

      };
      if (this.tabSelectName == 'third') {
        // 学生行为
        this.behaviorAddDialogShow = true;
      };
    },
    // tab切换
    handleClick(tab, event) {
      this.pageInfo = {
        pageSize: 10,
        pageNum: 1,
      };
      this.total = 0;
      this.interviewTime = "";
      this.tableData = [];
      this.detailData = null;
      this.refresh();
    },
    refresh() {
      if (this.tabSelectName == 'first') {
        // 家校沟通
        this.selectSchoolHomeInterviewList();
      };
      if (this.tabSelectName == 'second') {
        // 师生互动
        // this.selectTeacherStudentInteractList();
        this.selectTalkRecordDetailsList();
        // 学生基本信息
        this.getStudentDetailInfo();
      };
      if (this.tabSelectName == 'third') {
        // 学生行为
        this.selectStudentBehaviorList();
      }
      if (this.tabSelectName == 'fourth') {
        // 查询学生成绩详情
        this.selectAllExamInfoByStudentId();
      }
      if (this.tabSelectName == 'fifth') {
        // console.log(this.studentInfo)
        // 学生基本信息
        this.getStudentDetailInfo();
        // 重大经历
        this.getStudentExperience();
        // 学习生活评定项
        this.selectStudentLifeList();
        // 家庭情况
        this.selectStudentFamilyList();
        // 获取学生生活评定记录列表
        this.selectStudentLifeEvaluateList();
      }
      if (this.tabSelectName == 'sixth') {
        // 基础信息
        this.selectComprehensiveQualityDetailsByParam();
        // 查询综合评定项目
        this.selectComprehensiveQualityItem();
      };
    },
    // 提交综合素质评定
    async submitEvaluateBody() {
      // this.submitScores();
      const [scoresResult] = await Promise.all([
        this.submitScores()
      ]);

      if (scoresResult) {
        this.$message.success("保存成功");
      }
    },
    // 综合素质评定-基础信息提交
    async comprehensiveQualityDetailsSubmit() {
      let data = {
        "schoolId": this.school.id,
        "schoolName": this.school.schoolName,
        "gradeId": this.studentInfo.gradeId,
        "gradeName": this.studentInfo.gradeName,
        "classId": this.studentInfo.classId,
        "className": this.studentInfo.className,
        "schoolYear": this.searchData.schoolYear,
        "semester": this.searchData.semester,
        "studentId": this.studentInfo.id,
        "studentName": this.studentInfo.studentName,
        "classPosition": this.comprehensiveDetailsByParam.classPosition,
        "studentSummary": this.comprehensiveDetailsByParam.studentSummary,
        "teacherMessage": this.comprehensiveDetailsByParam.teacherMessage,
        "patriarchMessage": this.comprehensiveDetailsByParam.patriarchMessage,
        "createBy": this.user.id,
      };

      if (this.isHasComprehensiveQualityDetails) {
        data.id = this.comprehensiveDetailsByParam.id;
        try {
          const res = await this.put(this.$url.updateComprehensiveQualityDetails, data);
          if (res.code === 200) { return true; } else { this.$message.error(res.msg) }
        } catch (e) {
          return false;
        }
      } else {
        try {
          const res = await this.post(this.$url.insertComprehensiveQualityDetails, data);
          if (res.code === 200) { return true; } else { this.$message.error(res.msg) }
        } catch (e) {
          return false;
        }
      };
    },
    // 提交评分数据
    async submitScores() {
      const result = [];
      let hasError = false;
      let errorMessage = '以下项目评分未完成：\n';
      let errorMsg = '请补充完整评分信息';

      this.comprehensiveQualityItem.forEach((group, groupIndex) => {
        group.childQualityItem.forEach((child, childIndex) => {
          const selfValid = child.selfScore !== "";
          const teacherValid = child.teacherScore !== "";

          if (!selfValid || !teacherValid) {
            hasError = true;

            // 找出未评分的列名
            let missingFields = [];
            if (!selfValid) missingFields.push("自评");
            if (!teacherValid) missingFields.push("教师评");

            errorMessage += `${group.qualityItem} - ${child.qualityItem}：${missingFields.join('、')}未评分\n`;
          }

          result.push({
            id: null,
            schoolId: this.school.id,
            studentId: this.studentInfo.id,
            schoolYear: this.searchData.schoolYear,
            semester: this.searchData.semester,
            assessmentId: child.id,
            selfAssessment: child.selfScore || "",
            otherAssessment: child.teacherScore || ""
          });
        });
      });

      if (hasError) {
        this.$message.warning(errorMsg);
        return;
      };

      this.comprehensiveQualityDetailsSubmit()

      try {
        const res = await this.put(this.$url.editComprehensiveQualityAssessment, result);
        if (res.code === 200) { return true; } else { this.$message.error(res.msg) }
      } catch (e) {
        return false;
      }
    },
    // 选择评分
    selectScore(item, type, option) {
      if (type === 'self') {
        item.selfScore = option.dictValue;
      } else {
        item.teacherScore = option.dictValue;
      }
    },

    // 判断是否已选中
    isSelected(item, type, option) {
      return type === 'self'
        ? item.selfScore === option.dictValue
        : item.teacherScore === option.dictValue;
    },
    handleEdit(fieldPath, text) {
      const keys = fieldPath.split('.');
      let ref = this.comprehensiveDetailsByParam;

      for (let i = 0; i < keys.length - 1; i++) {
        ref = ref[keys[i]];
      }

      this.$prompt('', text, {
        inputValue: ref[keys[keys.length - 1]],
        inputValidator: val => !!val || '不能为空',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType: 'textarea'
      }).then(({ value }) => {
        Vue.set(ref, keys[keys.length - 1], value); // 使用 Vue.set 更新数据
      });
    },
    // 综合素质评定-查看综合评定项目
    selectComprehensiveQualityItem() {
      this.get(this.$url.selectComprehensiveQualityItem + '?schoolId=' + this.school.id).then(res => {
        // console.log("综合素质评定-查看综合评定项目", res);
        if (res.code !== 200) return;
        this.comprehensiveQualityItem = res.data.map(item => {
          return {
            ...item,
            childQualityItem: item.childQualityItem.map(child => {
              return {
                ...child,
                selfScore: '',
                teacherScore: ''
              }
            })
          }
        });

        // 查看综合评定项记录
        this.selectComprehensiveQualityAssessmentList();
      })
    },
    // 综合素质评定-查看综合评定项记录
    selectComprehensiveQualityAssessmentList() {
      let data = {
        studentId: this.studentInfo.id,
        schoolYear: this.searchData.schoolYear,
        semester: this.searchData.semester
      };
      this.get(this.$url.selectComprehensiveQualityAssessmentList, data).then(res => {
        // console.log("综合素质评定-查看综合评定项记录", res);
        if (res.code !== 200) return;
        this.comprehensiveAssessmentList = res.data;
        this.comprehensiveAssessmentList.forEach(record => {
          this.comprehensiveQualityItem.forEach(group => {
            const item = group.childQualityItem.find(i => i.id === record.assessmentId);
            if (item) {
              item.selfScore = record.selfAssessment;
              item.teacherScore = record.otherAssessment;
            }
          });
        });

        // console.log(this.comprehensiveQualityItem);

      });
    },
    // 综合素质评定-查询基础信息
    selectComprehensiveQualityDetailsByParam() {
      let data = {
        schoolId: this.school.id,
        studentId: this.studentInfo.id,
        schoolYear: this.searchData.schoolYear,
        semester: this.searchData.semester
      };
      this.get(this.$url.selectComprehensiveQualityDetailsByParam, data).then(res => {
        // console.log("综合素质评定-查询基础信息", res);
        if (res.code !== 200) return;
        if (res.data && res.data.id) {
          this.isHasComprehensiveQualityDetails = true;
          this.comprehensiveDetailsByParam = res.data;
        } else {
          this.isHasComprehensiveQualityDetails = false;
          this.comprehensiveDetailsByParam = {};
        };
      });
    },
    selectStudentFamilyList() {
      this.get(this.$url.selectStudentFamilyList + "?studentId=" + this.studentInfo.id).then(res => {
        // console.log("家庭成员:", res);
        if (res.code !== 200) return this.$message.error(res.msg);
        this.familyData = res.rows;
      })
    },
    // 学生学习生活评定
    selectStudentLifeList() {
      this.get(this.$url.selectStudentLifeList + "?schoolId=" + this.school.id).then(res => {
        // console.log(res);
        if (res.code == 200) {
          this.studentLifeList = res.rows;
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    // 学生基本信息点击确认
    async studentDetailInfoSubmit() {
      // console.log('重大事件备注：', this.otherRemark, '评定项目选中', this.evaluationResults, '重大事件选中', this.checkExperienceList);
      const unselected = this.studentLifeList.filter(item => !Object.keys(this.evaluationResults[item.id] || {}).some(k => this.evaluationResults[item.id][k]));

      if (unselected.length > 0) {
        this.$message.warning(`请完成所有评定项的选择`);
        return;
      };
      const [experienceResult, lifeResult] = await Promise.all([
        this.addStudentExperience(),
        this.addStudentLife()
      ]);

      if (experienceResult && lifeResult) {
        this.$message.success("保存成功");
      }

      // console.log(addStudentExperienceResult);
    },
    // 添加学生生活评定记录
    async addStudentLife() {
      const evaluateInfoList = this.studentLifeList.map(item => {
        // 获取当前行的选中状态
        const rowSelection = this.evaluationResults[item.id] || {};

        // 找出被选中的列（即 dictValue）
        const selectedStatus = Object.keys(rowSelection).find(key => rowSelection[key]);

        return {
          evaluateId: item.id,
          status: selectedStatus || null  // 如果没选中任何列，则为 null
        };
      });

      // 过滤掉未选择的项（可选）
      const filteredList = evaluateInfoList.filter(item => item.status !== null);

      // console.log('提交数据:', {
      //   evaluateInfoList: filteredList
      // });
      let data = {
        "schoolId": this.school.id,
        "schoolName": this.school.schoolName,
        "gradeId": this.studentInfo.gradeId,
        "gradeName": this.studentInfo.gradeName,
        "classId": this.studentInfo.classId,
        "className": this.studentInfo.className,
        "schoolYear": this.searchData.schoolYear,
        "semester": this.searchData.semester,
        "studentId": this.studentInfo.id,
        "studentName": this.studentInfo.studentName,
        "evaluateInfoList": filteredList
      };
      // console.log('提交数据:', data);

      try {
        const res = await this.post(this.$url.insertStudentLifeEvaluate, data);
        if (res.code === 200) { return true; } else { this.$message.error(res.msg) }
      } catch (e) {
        console.error('学生生活评定提交失败:', e);
        return false;
      };
    },
    // 添加或修改学生重大经历
    async addStudentExperience() {
      // 构建 label 到 value 的映射对象
      const labelToValue = Object.fromEntries(
        this.importantEventOptions.map(item => [item.dictLabel, item.dictValue])
      );
      let data = {
        "schoolId": this.school.id,
        "schoolName": this.school.schoolName,
        "gradeId": this.studentInfo.gradeId,
        "gradeName": this.studentInfo.gradeName,
        "classId": this.studentInfo.classId,
        "className": this.studentInfo.className,
        "schoolYear": this.searchData.schoolYear,
        "semester": this.searchData.semester,
        "studentId": this.studentInfo.id,
        "studentName": this.studentInfo.studentName,
        "status": this.checkExperienceList
          .map(label => labelToValue[label])
          .join(','),
        "remark": this.otherRemark || ''
      };
      if (this.hasExperience) {
        data.id = this.experienceId;
        try {
          const res = await this.put(this.$url.updateStudentExperience, data);
          if (res.code === 200) { return true; } else { this.$message.error(res.msg) }
        } catch (e) {
          console.error('学生重大经历提交失败:', e);
          return false;
        }
      } else {
        try {
          const res = await this.post(this.$url.insertStudentExperience, data);
          if (res.code === 200) { return true; } else { this.$message.error(res.msg) }
        } catch (e) {
          console.error('学生重大经历提交失败:', e);
          return false;
        }
      };

    },
    // 学生基本信息
    getStudentDetailInfo() {
      this.get(this.$url.getStudentDetailInfo + "?id=" + this.studentInfo.id).then(res => {
        // console.log("学生基本信息：", res);
        if (res.code !== 200) return this.$message.error(res.msg);
        this.studentDetailInfo = res.data;
      })
    },
    // 学生重大经历
    getStudentExperience() {
      let data = {
        studentId: this.studentInfo.id,
        schoolYear: this.searchData.schoolYear,
        semester: this.searchData.semester
      };
      this.get(this.$url.selectStudentExperience, data).then(res => {
        // console.log("重大经历:", res);
        if (res.code !== 200) return this.$message.error(res.msg);
        if (res.data) {
          // 将状态字符串转换为数组
          let statusArray = res.data.status.split(',');
          this.hasExperience = true;
          this.experienceId = res.data.id;
          if (statusArray.length > 0) {
            // 映射出符合条件的新数组
            this.checkExperienceList = this.importantEventOptions.filter(item => statusArray.includes(item.dictValue)).map(item => item.dictLabel);
            const hasOther = this.checkExperienceList.includes('其它重大事件');
            this.showOtherRemarkInput = hasOther;
            this.otherRemark = res.data.remark;
          } else {
            this.hasExperience = false;
          };
        } else {
          this.checkExperienceList = []; // 选中的重大事件列表
          this.showOtherRemarkInput = false; // 其它重大事件备注
          this.otherRemark = ''; // 其它重大事件备注
        }

      });
    },
    // 重大事件选中切换
    handleExperienceChange(e) {
      // console.log('选中项:', e);
      const hasOther = e.includes('其它重大事件');
      this.showOtherRemarkInput = hasOther;

      // 可选：如果取消勾选“其它重大事件”，清空备注
      if (!hasOther) {
        this.otherRemark = '';
      }
    },
    // 获取学生生活评定记录列表
    selectStudentLifeEvaluateList() {
      let data = {
        schoolId: this.school.id,
        studentId: this.studentInfo.id,
        schoolYear: this.searchData.schoolYear,
        semester: this.searchData.semester
      };
      this.get(this.$url.selectStudentLifeEvaluateList, data).then(res => {
        // console.log("获取学生生活评定记录列表", res);

        if (res.code !== 200) return this.evaluationResults = {};
        if (res.total === 0) return this.evaluationResults = {};
        // 状态码映射表（按你自己的业务逻辑配置）
        this.evaluationResults = this.convertToEvaluationResults(res.rows, this.evaluateBodyOptions);
      });
    },
    // 学生生活评定记录映射
    convertToEvaluationResults(rows, evaluateBodyOptions) {
      const evaluationResults = {};

      // 提取所有 dictValue 作为列键
      const columnKeys = evaluateBodyOptions.map(item => item.dictValue);

      rows.forEach(row => {
        const rowId = row.evaluateId.toString(); // 行ID（如：1, 2...）
        const selectedValue = row.status;        // 选中的 status（如："1", "2"...）

        // 初始化该行状态对象
        if (!evaluationResults[rowId]) {
          evaluationResults[rowId] = {};
          columnKeys.forEach(key => {
            evaluationResults[rowId][key] = false;
          });
        }

        // 设置选中项为 true
        if (columnKeys.includes(selectedValue)) {
          evaluationResults[rowId][selectedValue] = true;
        }
      });

      return evaluationResults;
    },
    // 学生评定项切换选中状态
    toggleSelection(rowId, colValue) {
      const row = this.evaluationResults[rowId] || {};

      // 获取当前所有同列互斥项
      const sameRowKeys = this.evaluateBodyOptions.map(c => c.dictValue);

      // 创建一个新的对象，防止直接修改原对象
      const newRow = { ...row };

      // 如果已选中，则取消；否则设为选中
      if (newRow[colValue]) {
        delete newRow[colValue];
      } else {
        // 如果只允许单选一行中的某一列，可取消其他列的选中
        sameRowKeys.forEach(key => delete newRow[key]);
        newRow[colValue] = true;
      }

      this.$set(this.evaluationResults, rowId, newRow);
    },
    // 获取当前是否选中
    getSelectionStatus(rowId, colValue) {
      return !!this.evaluationResults[rowId]?.[colValue];
    },
    // 重大事件字典
    getImportantEvent() {
      this.get(`${this.$url.getDictType}/sc_important_event`).then((res) => {
        this.importantEventOptions = res.data;
      });
    },
    // 评定主体字典
    getEvaluateBody() {
      this.get(`${this.$url.getDictType}/sc_general_evaluate`).then((res) => {
        this.evaluateBodyOptions = res.data;
      });
    },
    // 分页组件传递过来的页码修改事件
    currentPageNumChange(pageNum) {
      this.pageInfo.pageNum = pageNum;
      this.refresh();
    },
    handleSizeChange(pageSize) {
      this.pageInfo.pageSize = pageSize;
      this.refresh();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./studentRecordDetail.scss";
</style>